import React, { useMemo } from "react";
import PhoneInputLib from "react-phone-number-input";
import ptLabels from "react-phone-number-input/locale/pt.json";
import enLabels from "react-phone-number-input/locale/en.json";
import esLabels from "react-phone-number-input/locale/es.json";
import "react-phone-number-input/style.css";
import "./PhoneInput.css";

const PhoneInput = ({
  value,
  onChange,
  disabled,
  placeholder = "Digite seu número de telefone",
  defaultCountry = "BR",
  ...props
}) => {
  const labels = useMemo(() => {
    const locale = localStorage.getItem("__extraconomy_locale") || "pt";

    switch (locale) {
      case "pt":
      case "pt-BR":
        return ptLabels;
      case "en":
      case "en-US":
        return enLabels;
      case "es":
      case "es-ES":
        return esLabels;
      default:
        return ptLabels;
    }
  }, []);

  return (
    <div className="custom-phone-input">
      <PhoneInputLib
        international
        defaultCountry={defaultCountry}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        labels={labels}
        {...props}
      />
    </div>
  );
};

export default PhoneInput;
